import React, { useState } from "react";
import { X } from "lucide-react";

export default function AddUserModal({
  isOpen,
  onClose,
  onSave,
  editUser = null,
}) {
  const [formData, setFormData] = useState({
    username: editUser?.name || "",
    email: editUser?.email || "",
    role: editUser?.role || "Admin",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl p-6 sm:p-8 animate-fade-in max-h-[90vh] overflow-y-auto">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close modal"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Header */}
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6 pr-8">
          {editUser ? "Edit User" : "Add New User"}
        </h2>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Full Name */}
          <div>
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Full Name
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter Full Name"
              className="w-full h-[50px] xxl:h-[40px] px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              required
            />
          </div>

          {/* Email Id */}
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Email Id
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter Email Id"
              className="w-full h-[50px] xxl:h-[40px] px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              required
            />
          </div>
          {/* User Type */}
          <div className="flex items-center gap-3">
            <label className="block text-sm font-semibold text-gray-700 mb-0">
              User Type
            </label>
            <div className="flex gap-6">
              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="role"
                  value="Admin"
                  checked={formData.role === "Admin"}
                  onChange={handleChange}
                  className="w-5 h-5 text-teal-600 focus:ring-2 focus:ring-teal-500 cursor-pointer"
                />
                <span className="ml-2 text-gray-700">Admin</span>
              </label>
              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="role"
                  value="User"
                  checked={formData.role === "User"}
                  onChange={handleChange}
                  className="w-5 h-5 text-teal-600 focus:ring-2 focus:ring-teal-500 cursor-pointer"
                />
                <span className="ml-2 text-gray-700">User</span>
              </label>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col-reverse sm:flex-row gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="common-btn flex-1 px-6 py-3 border-2 border-teal-600 text-teal-600 font-semibold rounded-lg transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="common-btn white-btn flex-1 px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg border-2 border-teal-600 "
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
